import {type Ref, ref} from "vue";

export function useFilter() {
    const open: Ref<boolean> = ref(false)
    function isSelected(){
        return false
    }

    function setIsOpen(isOpen: boolean) {
        open.value = isOpen
    }

    function apply() {
        setIsOpen(false)
    }

    return {
        setIsOpen,
        open,
        apply,
        isSelected
    }
}